import type { PayoutMethod } from "@/types";
import { normalizeBankAccount } from "@/lib/bank-account";

/** Podaci za isplatu iz kojih se popunjava ugovorna strana "Psihoterapeut". */
export interface TherapistPartyInput {
  name: string;
  payoutMethod: PayoutMethod | null | undefined;
  businessName?: string | null;
  businessAddress?: string | null;
  businessTaxId?: string | null;
  personalAddress?: string | null;
  personalTaxId?: string | null;
  bankName?: string | null;
  bankAccount?: string | null;
}

/**
 * Vrijednosti placeholdera ugovorne strane u ugovoru. Terapeut sa obrtom/firmom
 * (`invoice`) ugovara kao taj subjekt: naziv, adresa i JIB firme. Terapeut pod
 * ugovorom o djelu ugovara lično: ime i prezime, adresa stanovanja i JMBG.
 * Banka i broj računa za isplatu važe za oba slučaja.
 * Čist modul: koristi ga server (PDF, prikaz) i onboarding, koji ugovor popunjava
 * uživo dok terapeut kuca podatke za isplatu.
 */
export function therapistPartyValues(input: TherapistPartyInput): Record<string, string> {
  const trim = (v: string | null | undefined) => (v ?? "").trim();
  // Račun za isplatu ne zavisi od načina isplate. Normalizuje se isto kao pri
  // spremanju, da živi prikaz u onboardingu izgleda kao PDF.
  const bank = {
    "terapeut.banka": trim(input.bankName),
    "terapeut.brojRacuna": normalizeBankAccount(trim(input.bankAccount)),
  };
  if (input.payoutMethod === "invoice") {
    return {
      "terapeut.ugovornaStrana": trim(input.businessName) || trim(input.name),
      "terapeut.adresa": trim(input.businessAddress),
      "terapeut.idBroj": trim(input.businessTaxId),
      ...bank,
    };
  }
  return {
    "terapeut.ugovornaStrana": trim(input.name),
    "terapeut.adresa": trim(input.personalAddress),
    "terapeut.idBroj": trim(input.personalTaxId),
    ...bank,
  };
}
